module.exports = __webpack_public_path__ + "img/buhua.b804370d.png";